module.exports = __webpack_public_path__ + "static/img/oregon-coast-wayside-signs18.9ec03d1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/oregon/oregon-coast-wayside-signs18.jpg
// module id = 881
// module chunks = 0